export default __webpack_public_path__ + "static/media/section-malvorlagen.5f61f260.webp";